import colors from "@constants/colors"
import { body14BoldStyles, body14Styles } from "@constants/typography"
import styled from "styled-components"

export const Text = styled.span`
  ${body14Styles}
  color: ${colors.offBlack};
`

export const TextBold = styled.span`
  ${body14BoldStyles}
  color: ${colors.black};
`

export const Spacer = styled.span`
  display: inline-block;
  width: 3px;
`
